import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2026"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.561 3.693s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.019 14.124a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.607.607 0 0 0-.101-1.129z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m12.245 13.665.707-2.191 1.007.325a.198.198 0 0 0 .23-.29l-2.246-3.706a.197.197 0 0 0-.246-.079L7.708 9.416a.198.198 0 0 0 .016.37l1.007.325-1.147 3.553H5.182v1.159h9.819v-1.159h-2.756zm-3-1.568a.307.307 0 0 1 .387-.198l1.544.498c.162.052.25.225.198.387l-.284.88H8.739l.506-1.567z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }